// Menu functionality
export function menuToggleTweak() {
  setTimeout(function () {
    const btn = document.querySelector('button.menu-toggle');
    if (btn) {
      const span = document.createElement('span');
      span.textContent = btn.textContent;
      btn.textContent = '';
      btn.appendChild(span);
    }
  }, 100);
}
